import {useCallback, useEffect, useState} from 'react'
import {useAuth} from './core/Auth'

export function Logout() {
  const {logout} = useAuth()
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(true)

  const completeLogout = useCallback(async () => {
    setLoading(true)
    setError('')
    const completed = await logout()
    if (completed) {
      window.location.replace('/auth/login')
      return
    }

    setLoading(false)
    setError(
      'Kullanıcı geçişi sunucuda kapatılamadı. Bağlantıyı kontrol edip güvenli çıkışı yeniden deneyin.'
    )
  }, [logout])

  useEffect(() => {
    void completeLogout()
  }, [completeLogout])

  return (
    <div className='d-flex flex-column flex-center min-vh-100 gap-4 p-5 text-center'>
      {loading && <span className='spinner-border' aria-label='Güvenli çıkış yapılıyor' />}
      {error && <div className='alert alert-danger mb-0'>{error}</div>}
      {!loading && (
        <button type='button' className='btn btn-dark' onClick={() => void completeLogout()}>
          Güvenli çıkışı yeniden dene
        </button>
      )}
    </div>
  )
}
